//存健康数据
import { GET_INDEX_HEALTHY_DATA } from "./actionType";

const defaultState = {
  healthyData: [],
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_INDEX_HEALTHY_DATA://存
      return { ...state, ...action };
    default:
      return state;
  }
};

export default Reducer;
